export const getDefault = () => {
  const schema = {
    name: 'SubWebCourses',
  };
  return schema;
};
